import { Component, OnInit } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';

import { DialogEmailTypeEnum, IEmailTemplateInfo } from 'src/app/models/email';
import { ModalAddEmailComponent } from './modal-add-email/modal-add-email.component';
import {
  IBatchEmailConfig,
  ICustomSelect,
  IGenericResult,
  IHeaderItem
} from 'src/app/models/generic';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { EmailService } from 'src/app/services/api/email.service';
import { DataService } from 'src/app/services/data.service';
import { ApiTransferConfigService } from 'src/app/services/api/api-transfer-config.service';
import { ApiLotsService } from 'src/app/services/api/api-lots.service';

interface ITemplateGroup {
  title: string;
  template: DialogEmailTypeEnum;
}

@Component({
  selector: 'app-configuracoes-email',
  templateUrl: './configuracoes-email.component.html',
  styleUrls: ['./configuracoes-email.component.scss']
})
export class ConfiguracoesEmailComponent implements OnInit {
  typeRepasse = 1;
  typeFaturamento = 2;

  DialogEmailTypeEnum = DialogEmailTypeEnum;

  repasseTemplates: IEmailTemplateInfo[] = [];
  faturamentoTemplates: IEmailTemplateInfo[] = [];

  templateGroups: ITemplateGroup[] = [
    { title: 'Repasse', template: DialogEmailTypeEnum.Transfer },
    { title: 'Faturamento', template: DialogEmailTypeEnum.Invoice }
  ];

  headerRepasse: IHeaderItem[] = [
    { label: 'Canal', flexSize: 2, justify: 'flex-start' },
    { label: 'Assunto', flexSize: 4 },
    { label: 'Tipo', flexSize: 2 }
  ];

  headerFaturamento: IHeaderItem[] = [
    { label: 'Banco', flexSize: 2, justify: 'flex-start' },
    { label: 'Assunto', flexSize: 4 },
    { label: 'Tipo', flexSize: 2 },
    { label: 'Disparo', flexSize: 3 },
    { label: '', flexSize: 2 }
  ];

  bankOpts: ICustomSelect[] = [];
  channelOpts: ICustomSelect[] = [];

  constructor(
    private _emailService: EmailService,
    private _dialog: MatDialog,
    private _dataService: DataService,
    private _batchConfigService: ApiTransferConfigService,
    private _snackbarService: SnackbarService,
    private _lotsService: ApiLotsService
  ) {}

  ngOnInit(): void {
    this._dataService.handleEmailModalClose.subscribe({
      next: () => {
        this.getEmailTemplates();
      }
    });
    this.getChannelConfig();
  }

  getEmailTemplates(): void {
    this._emailService
      .getEmailTemplateList()
      .subscribe(
        ([transferTemplates, invoiceTemplates]: IGenericResult<
          IEmailTemplateInfo[]
        >[]) => {
          this.repasseTemplates = transferTemplates.Data;
          this.faturamentoTemplates = invoiceTemplates.Data;
          
          this.getBatchEmailConfig();
        }
      );
  }

  getBatchEmailConfig(): void {
    this._lotsService.getBatchEmailConfig().subscribe({
      next: (response) => {
        if (response.Data.length > 0) {
          this.insertBatchConfigProperties(response.Data);
        }
      }
    });
  }

  insertBatchConfigProperties(batchConfigs: IBatchEmailConfig[]): void {
    this.faturamentoTemplates = this.faturamentoTemplates.map((template) => {
      const batchConfig = batchConfigs.find(
        (config) => config.Name === template.EventName.split('.')[0]
      );
      const newTemplate = {
        ...template,
        ...batchConfig
      };

      return newTemplate;
    });
  }

  getChannelConfig(): void {
    const channel$ = this._batchConfigService.getChannel();

    const bankAndChannel$ = forkJoin([channel$]);

    bankAndChannel$.subscribe({
      next: ([channels]) => {
        this.channelOpts = channels;
      }
    });
  }

  openAddEmailDialog(): void {
    const dialogRef = this._dialog.open(ModalAddEmailComponent, {
      disableClose: true,
      panelClass: 'reset-modal-style',
      data: {
        bankOpts: this.bankOpts,
        channelOpts: this.channelOpts
      }
    });

    dialogRef.afterClosed().subscribe({
      next: (parameter: IEmailTemplateInfo) => {
        if (parameter) {
          this._snackbarService.openSnackBar(
            'Template criado com sucesso!',
            'success'
          );
          this.repasseTemplates.push(parameter);
        }
      }
    });
  }

  deleteParameter(index: number): void {
    this.repasseTemplates.splice(index, 1);
  }
}
